const RatingChoices = ({
  ratingChoices,
  selectedRating,
  onSelect,
  hasLowRatings = [],
  setImprovementReason,
}) => (
  <div className="grid grid-cols-5 gap-4">
    {ratingChoices.map(({ label, emoji }, index) => {
      const isSelected = selectedRating === index + 1;
      return (
        <div
          key={index}
          className={`flex flex-col items-center justify-center gap-1 rounded-xl px-6 pt-3 pb-3 cursor-pointer ${
            isSelected
              ? "bg-primary-50 border-4 border-primary hover:bg-primary-50"
              : "bg-grey-25 border-4 border-transparent hover:border-2 hover:border-grey-border hover:bg-grey-50"
          }`}
          onClick={() => {
            onSelect(index + 1);
            if (setImprovementReason && !hasLowRatings.includes(label)) setImprovementReason(null);
          }}
        >
          <div className="flex flex-col gap-2 items-center">
            <h1 className="text-5xl">{emoji}</h1>
            <p className="text-xs font-bold">{label}</p>
          </div>
        </div>
      );
    })}
  </div>
);

export default RatingChoices;
